import { createSlice } from '@reduxjs/toolkit';

// Most of the usage is for retrack report
export const retrackSlice = createSlice({
    name: 'retrack',
    initialState: {
        handleValidateRetrackReport: () => {},
        retrackReportIsValid: false,
        retrackReportFormData: {},

        handleValidateRetrackEndReason: () => {},
        retrackEndReasonData: {},

        isRetrackUnsuccessfulState: false, // Purpose: used to control showing retrack reload retrack file and impression button in NewPatientPhotos.js
        setIsRetrackUnsuccessfulState: () => {},
    },
    reducers: {
        setHandleValidateRetrackReport: (state, action) => {
            // console.log('action.payload setHandleValidateRetrackReport: ', action.payload);
            state.handleValidateRetrackReport = action.payload;
        },
        setRetrackReportIsValid: (state, action) => {
            state.retrackReportIsValid = action.payload;
        },
        setRetrackReportFormData: (state, action) => {
            // console.log('action.payload setRetrackReportFormData: ', action.payload);
            state.retrackReportFormData = action.payload;
        },
        setRetrackEndReasonData: (state, action) => {
            // console.log('action.payload setRetrackEndReasonData: ', action.payload);
            state.retrackEndReasonData = action.payload;
        },
        setHandleValidateRetrackEndReason: (state, action) => {
            state.handleValidateRetrackEndReason = action.payload;
        },
        setIsRetrackUnsuccessfulState: (state, action) => {
            state.isRetrackUnsuccessfulState = action.payload;
        },
    },
});

export const {
    setHandleValidateRetrackReport,
    setRetrackReportIsValid,
    setRetrackReportFormData,
    setRetrackEndReasonData,
    setHandleValidateRetrackEndReason,
    setIsRetrackUnsuccessfulState,
} = retrackSlice.actions;

export default retrackSlice.reducer;
